import { ChangeDetectionStrategy, Component, ElementRef, viewChild } from "@angular/core";

@Component({
    selector: 'app-register-succes',
    templateUrl: './register-success.component.html',
    styleUrls: ['./register-success.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RegisterSuccessComponent {
    readonly dialog = viewChild.required<ElementRef<HTMLDialogElement>>('dialog');

    onShowModal(): void {
        this.dialog().nativeElement.showModal();
    }

    onCloseModal(): void {
        this.dialog().nativeElement.close();
    }

    onBackdropClick(event: MouseEvent): void {
        if (event.target === this.dialog().nativeElement) {
            this.onCloseModal();
        }
    }
}